import brandConfig from 'brandConfig'
import { STATIC_LOGO_URL } from '../constants/app'
import { isTokenTypeNft } from './pointsExchange.helpers'
import { toLower } from './string.helpers'

const isNftToken = (token) => {
  return isTokenTypeNft(token?.type)
}

const getNonNegativeNumber = (value) => {
  return value > 0 ? value : 0
}

const getCashbackParams = () => {
  const { altName, name, loyalizePid } = brandConfig
  return `&sid=${altName || name}&pid=${loyalizePid}`
}

const getStaticLogoPath = (symbol) => {
  return symbol ? `${STATIC_LOGO_URL}${toLower(symbol)}.png` : ''
}

export {
  isNftToken,
  getNonNegativeNumber,
  getCashbackParams,
  getStaticLogoPath
}
